import {
  AutocompleteInput,
  ReferenceInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const filterToQuery = (searchText) => ({ all: searchText });

const accountReceivablePcmOverviewFilterList = [
  <MuiDatePickerInput
    alwaysOn
    source="start_date"
    variant="outlined"
    label="mine.label.start_date"
    maxDateSource="end_date"
  />,
  <MuiDatePickerInput
    alwaysOn
    source="end_date"
    variant="outlined"
    label="mine.label.end_date"
    minDateSource="start_date"
  />,
  <MuiDatePickerInput
    alwaysOn
    source="cut_off"
    variant="outlined"
    // label=""
  />,
  <ReferenceInput
    alwaysOn
    source="code"
    reference="customers"
    sort={{ field: "customers.created_at", order: "ASC" }}
    perPage={50}
  >
    <AutocompleteInput
      optionValue="id"
      optionText="code"
      variant="outlined"
      label="mine.label.code"
    />
  </ReferenceInput>,
  <ReferenceInput
    alwaysOn
    resettable
    source="name"
    reference="customers"
    sort={{ field: "customers.name", order: "ASC" }}
    perPage={25}
  >
    <AutocompleteInput
      resettable
      optionValue="name"
      optionText="name"
      filterToQuery={filterToQuery}
      variant="outlined"
      label="mine.label.name"
    />
  </ReferenceInput>,
];

export default accountReceivablePcmOverviewFilterList;
